export default __webpack_public_path__ + "static/media/1.8d36144a.png";